export default "__VITE_ASSET__Cq3jpF$s__"